function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectionCard = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("../../Button");
var _Text = require("../../Text");
var _styles = require("./styles");
var _utils = require("../../../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var SelectionCard = exports.SelectionCard = (0, _react.memo)(function (_ref) {
  var _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    id = _ref.id,
    label = _ref.label,
    description = _ref.description,
    onSelect = _ref.onSelect,
    style = _ref.style;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _isPointerOver = _useState2[0],
    _setIsPointerOver = _useState2[1];
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _hasDescription = !!description;
  var _descriptionId = (0, _react.useMemo)(function () {
    return _hasDescription ? (0, _utils.GenerateId)() : undefined;
  }, [_hasDescription]);
  var _onPress = function _onPress() {
    return onSelect == null ? void 0 : onSelect(id);
  };
  var _onPointerEnter = function _onPointerEnter() {
    _setIsPointerOver(true);
  };
  var _onPointerLeave = function _onPointerLeave() {
    _setIsPointerOver(false);
  };
  return (0, _jsxRuntime.jsxs)(_Button.Button, {
    type: _Button.ButtonType.blank,
    nativeContainerStyle: styles.nativeContainer,
    containerStyle: [styles.container, style],
    textStyle: [styles.text, selected && styles.text_selected, _isPointerOver && styles.text_pointerOver],
    testID: "SelectionCard",
    label: label,
    onPress: _onPress,
    description: description,
    descriptionId: _descriptionId,
    state: {
      selected: selected
    },
    onPointerEnter: _onPointerEnter,
    onPointerLeave: _onPointerLeave,
    children: [(0, _jsxRuntime.jsx)(_Text.Text, {
      containerStyle: styles.labelContainer,
      textStyle: [styles.label, selected && styles.label_selected],
      children: label
    }), _hasDescription && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [(0, _jsxRuntime.jsx)(_Text.Text, {
        children: "\n"
      }), (0, _jsxRuntime.jsx)(_Text.Text, {
        containerStyle: styles.descriptionContainer,
        textStyle: [styles.description, selected && styles.description_selected],
        nativeID: _descriptionId,
        children: description
      })]
    })]
  });
});